module.exports = __webpack_public_path__ + "assets/img/CalculatorBAPC.eacfc5f2.png";